module.exports = __webpack_public_path__ + "89889688147bd7575d6327160d64e760.svg";